import { type ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useRedirectToLogin from '@/hooks/useRedirectToLogin';

interface PrivateRouteProps {
  children?: ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const redirectToLogin = useRedirectToLogin();
  const token = localStorage.getItem('token') ?? null;
  const location = useLocation();

  if (!token) {
    return (
      <Navigate to={redirectToLogin()} state={{ from: location }} replace />
    );
  }

  return children ?? <Outlet />;
};

export default PrivateRoute;
